import { Fragment } from 'react';
import { ClothesImage, CurrencyIcon } from '~/components/collections';
import { useWalletIcon } from '~/hooks';
import { WalletType, walletTypeCurrency } from '~/shared';
import { Text } from '../Text';
import {
	StyledArrow,
	StyledCategory,
	StyledContainer,
	StyledDownButton,
	StyledImageBg,
	StyledImageContainer,
	StyledImageWrapper,
	StyledInfoContainer,
	StyledNewDot,
	StyledNewShadow,
	StyledOldPriceContainer,
	StyledPriceContainer,
	StyledPricesContainer,
	StyledTitle,
	StyledUpButton,
	StyledVariationButtons,
} from './ShopClothesItem.styled';

interface IShopClothesItemProps {
	itemId: string;
	title: string;
	category: string;
	price: number;
	oldPrice?: number;
	discount?: number;
	walletType: WalletType;
	active: boolean;
	variantIndex?: number;
	maxVariantIndex?: number;
	isNew: boolean;
	handleClick: () => void;
	handlePrevVariant: () => void;
	handleNextVariant: () => void;
}

const ShopClothesItem = ({
	itemId,
	title,
	category,
	price,
	oldPrice,
	walletType,
	active,
	variantIndex,
	maxVariantIndex,
	isNew,
	handleClick,
	handlePrevVariant,
	handleNextVariant,
	...props
}: IShopClothesItemProps & React.HTMLAttributes<HTMLDivElement>) => {
	const currencyIcon = useWalletIcon(walletTypeCurrency[walletType], true);

	return (
		<StyledContainer
			$invertCurrency={walletType !== WalletType.Donate}
			$active={active}
			onClick={handleClick}
			{...props}
		>
			<StyledImageContainer>
				<StyledImageBg />
				<StyledImageWrapper>
					<ClothesImage id={itemId} size={60} />
				</StyledImageWrapper>
				{isNew && (
					<Fragment>
						<StyledNewShadow />
						<StyledNewDot />
					</Fragment>
				)}
			</StyledImageContainer>
			<StyledInfoContainer>
				<div>
					<StyledCategory>{category}</StyledCategory>
					<StyledTitle>
						<Text>{title}</Text>
						{variantIndex !== undefined && (
							<Text>
								( {variantIndex} / {maxVariantIndex} )
							</Text>
						)}
					</StyledTitle>
					<StyledPricesContainer>
						<StyledPriceContainer>
							<CurrencyIcon icon={currencyIcon} size="sm" />
							<Text>{price.toLocaleString('ru-RU')}</Text>
						</StyledPriceContainer>
						{oldPrice && (
							<StyledOldPriceContainer>
								<CurrencyIcon icon={currencyIcon} size="sm" />
								<Text>{oldPrice.toLocaleString('ru-RU')}</Text>
								<div className="line"></div>
							</StyledOldPriceContainer>
						)}
					</StyledPricesContainer>
				</div>
				{maxVariantIndex && maxVariantIndex > 1 && (
					<StyledVariationButtons>
						<StyledUpButton onClick={handlePrevVariant}>
							<StyledArrow />
						</StyledUpButton>
						<StyledDownButton onClick={handleNextVariant}>
							<StyledArrow />
						</StyledDownButton>
					</StyledVariationButtons>
				)}
			</StyledInfoContainer>
		</StyledContainer>
	);
};

export { ShopClothesItem };
